import React from 'react';

const MapIcon = () => {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.00033 0.666504C2.77533 0.666504 0.166992 3.27484 0.166992 6.49984C0.166992 10.8748 6.00033 17.3332 6.00033 17.3332C6.00033 17.3332 11.8337 10.8748 11.8337 6.49984C11.8337 3.27484 9.22533 0.666504 6.00033 0.666504ZM6.00033 8.58317C4.85033 8.58317 3.91699 7.64984 3.91699 6.49984C3.91699 5.34984 4.85033 4.4165 6.00033 4.4165C7.15033 4.4165 8.08366 5.34984 8.08366 6.49984C8.08366 7.64984 7.15033 8.58317 6.00033 8.58317Z" fill="currentColor"/>
    </svg>
  )
}

export default MapIcon;